import { AlertTriangle } from "lucide-react";
import { formatDate } from "@/utils/format";

interface FfcExpiryWarningProps {
  ffcExpiryDate: string;
}

export function FfcExpiryWarning({ ffcExpiryDate }: FfcExpiryWarningProps) {
  const expiry = new Date(ffcExpiryDate);
  const now = new Date();
  const daysUntilExpiry = Math.ceil((expiry.getTime() - now.getTime()) / 86400000);

  if (daysUntilExpiry > 30 || daysUntilExpiry < 0) return null;

  const isUrgent = daysUntilExpiry <= 7;

  return (
    <div
      className={`rounded-lg border p-4 flex items-start gap-3 ${
        isUrgent
          ? "bg-red-500/10 border-red-500/30 text-red-400"
          : "bg-amber-500/10 border-amber-500/30 text-amber-400"
      }`}
    >
      <AlertTriangle className="h-5 w-5 mt-0.5 flex-shrink-0" />
      <div>
        <p className="font-semibold text-sm">
          {isUrgent
            ? `FFC expires in ${daysUntilExpiry} day${daysUntilExpiry !== 1 ? "s" : ""}!`
            : `FFC expiring soon — ${daysUntilExpiry} days remaining`}
        </p>
        <p className="text-xs mt-1 opacity-80">
          Your Fidelity Fund Certificate expires on{" "}
          {formatDate(expiry)}. Renew with the PPRA to maintain your
          verified status and continue responding to owner requests.
        </p>
      </div>
    </div>
  );
}
